import { includes } from 'lodash';
import { LANDING_TEMPLATES as LT } from 'src/constants/landings';

export function providesOrderingSkus(landing) {
  const orderingTemplates = [LT.PRODUCT_MULTIPLE_SKU, LT.PRODUCT_SINGLE_SKU, LT.MULTIPLE_ACCOUNT_SKU, LT.SMB_SKU];
  return includes(orderingTemplates, landing.template);
}
